import thumbnail1 from './assets/thumbnail-1.svg';

const previewOccurrenceReportExcelFactory = () => {
  return [thumbnail1];
};

export { previewOccurrenceReportExcelFactory };
